(function (ws) {
    'use strict';

    ws.views.ajaxAddressSearch = Backbone.View.extend({

        /**
         * Extend Options
         */
        options: {},

        /**
         * Initialize
         */
        initialize: function () {
            this.type = this.$('.select-address-from-ajax').data('type');
            this.addressSearch = $(`#${this.$('.select-address-from-ajax').data('event')}`);
            this.addressSearchAndSelect(this.addressSearch);
        },

        getDefaultAddress: function (field) {
            return _.map(field.children(), function (option) {
                return {
                    id: option.value,
                    text: option.text,
                    element: option
                };
            });
        },

        addressSearchAndSelect: function(field) {
            this.url = isOrderEntrySite ? globals.path.api.orderentry.addressSearchTrillium : globals.path.api.quoting.addressSearchTrillium;
            let defaultOptions = this.getDefaultAddress(field);
            let type = this.type === 'SHIPTO' ? 'Ship To' : 'End User';
            let lastErrorMessage = null;

            field.select2({
                placeholder: `--Select the ${type} from the Partner's Address Book--`,
                templateResult: function (data, container) {
                    if (data.element) {
                        $(container).addClass($(data.element).attr('class'));
                    }

                    return data.text;
                },

                ajax: {
                    url: this.url,
                    dataType: 'json',
                    delay: 250,
                    data: params => {
                        return {
                            searchText: params.term ? params.term : '',
                            accountType: this.type,
                            resellerId: $('[name=sba-resellerAccount]').val(),
                            salesOrg: $('#sales-org-input').val() || $('#salesOrg').val() || $('.salesOrg').val()
                        };
                    },

                    processResults: function (data, params) {
                        lastErrorMessage = data.error ? data.error : null;
                        return {
                            results: _.map(data.addresses, function (element) {
                                element.company = element.company.replace('&#40;', '(').replace('&#41;', ')');
                                let addressText = `${element.sapId ? element.sapId + ' ' : ''}${element.company ? element.company + ', ' : ''}${element.line1 ? element.line1 + ', ' : ''}${element.line2 ? element.line2 + ', ' : ''}${element.line3 ? element.line3 + ', ' : ''}${element.line4 ? element.line4 + ', ' : ''}${element.locality ? element.locality + ', ' : ''}${element.town ? element.town + ', ' : ''}${element.state ? element.state + ', ' : ''}${element.postalcode ? element.postalcode + ', ' : ''}${element.country ? element.country : ''}`;
                                return {
                                    id: element.sapId,
                                    text: addressText,
                                    object: element
                                };
                            })
                        };
                    },

                    placeholder: 'Searching',
                    cache: true
                },
                language: {
                    noResults: function() {
                        if (lastErrorMessage) {
                            return `<span class="select2-custom-error error-message">${lastErrorMessage}</span>`;
                        } else {
                            return `No results found`;
                        }
                    }
                },
                escapeMarkup: function (markup) {
                    return markup;
                }
            });
        }
    });
})(westcon);
